module.exports = __webpack_public_path__ + "shell/assets/brand/suse/dark/rancher-logo.svg";